import React, { useState } from "react";
import "./VideoControls.css";
import { confirmAlert } from "react-confirm-alert";
import {
  Camera,
  CameraOff,
  Mic,
  MicOff,
  Phone,
  SwitchCamera,
  Users,
} from "lucide-react";
import { UserListModal } from "./Modals/UserListModals";
import { userProfile } from "../images";

export const VideoContainer = ({
  flip,
  stream,
  username,
  isLocal,
  isVideoEnabled,
  isAudioEnabled,
  isReconnecting,
  profileImg, // Add this prop to receive the profile image URL
}) => {
  return (
    <div className="video-container">
      {stream && (
        <video
          className={`video-element ${flip ? "invert" : "facingMode"}`}
          autoPlay
          playsInline
          muted={isLocal}
          ref={(video) => {
            if (video && video.srcObject !== stream) {
              video.srcObject = stream;
            }
          }}
        />
      )}
      {!isVideoEnabled && (
        <div className="profile-container">
          <img src={profileImg && profileImg !== "undefined" ? profileImg : userProfile} alt={``} className="profile-image" draggable={false} />
        </div>
      )}
      {
        !isAudioEnabled && (
          <div className="Audio-disable">
            <div className="mic-section">
              <MicOff />
            </div>
          </div>
        )
      }
      <div className="participant-info">
        <div className="participant-status">
          <div className="status-indicator" />
          <span className="participant-name">
            {isLocal ? "You" : username}{" "}
            {isReconnecting ? "(Reconnecting...)" : ""}
          </span>
        </div>
      </div>
    </div>
  );
};

export const VideoControls = ({
  roomId,
  isAudioEnabled,
  isVideoEnabled,
  onToggleAudio,
  onToggleVideo,
  isDisable,
  switchCamera,
  onLeaveRoom,
  users,
  roomName
}) => {
  const [showUserList, setShowUserList] = useState(false);
  const leave = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="confirm-dialog-overlay">
            <div className="confirm-dialog-box">
              <h3>Are you sure you want to leave the room?</h3>
              <div className="confirm-dialog-buttons">
                <button
                  className="confirm-dialog-button cancel"
                  onClick={onClose}
                >
                  No
                </button>
                <button
                  className="confirm-dialog-button confirm"
                  onClick={() => {
                    onLeaveRoom();
                    onClose();
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  return (
    <>
      <div className="controls-container">
        <div className="controls-content">
          <div className="room-name">Room {roomName}</div>
          <button
            className={`control-button ${isAudioEnabled ? "primary" : "secondary"
              }`}
            onClick={onToggleAudio}
            disabled={isDisable}
          >
            {isAudioEnabled ? <Mic /> : <MicOff />}
          </button>
          <button
            className={`control-button ${isVideoEnabled ? "primary" : "secondary"
              }`}
            onClick={onToggleVideo}
            disabled={isDisable}
          >
            {isVideoEnabled ? <Camera /> : <CameraOff />}
          </button>
          {isVideoEnabled && <button className="control-button primary" onClick={switchCamera} disabled={isDisable}>
            <SwitchCamera />
          </button>}
          <button
            className="control-button primary"
            onClick={() => setShowUserList(true)}
          >
            <Users />
          </button>
          <button className="control-button danger" onClick={leave}>
            <Phone />
          </button>
        </div>
      </div>

      <UserListModal
        isOpen={showUserList}
        roomName={roomName}
        onClose={() => setShowUserList(false)}
        users={users}
        roomId={roomId}
      />
    </>
  );
};
